var OrderSubmitLoader = (function ($) {
    "use strict";

    var loadingAnimation = function (status) {
        if (status === true) {
            $(".order-submit-loader").removeClass("hiddenLoader");

            var countdownTimer = $("#countdown-timer");
            if (countdownTimer.length) {
                initCountdown(countdownTimer);
            }
        } else {
            $(".order-submit-loader").addClass("hiddenLoader");
        }
    };

    var initCountdown = function initCountdown(countdownTimer) {
        var distance = 10;
        var x = setInterval(function () {

            countdownTimer.html(distance);

            if (distance < 0) {
                clearInterval(x);
                $("#countdown-timer").html("");
            }

            distance--;

        }, 1000);
    };

    var addOrderSubmitListener = function (submitBtn) {
        submitBtn.on("click", function () {
            loadingAnimation(true);
        });
    };

    return {
        loadingAnimation: loadingAnimation,
        initCountdown: initCountdown,
        addOrderSubmitListener: addOrderSubmitListener
    }
}(window.jQuery));


$(document).ready(function () {
    var submitBtn = $("#s_q").find(".checkout-submit-btn");
    var loaderBlock = $(".order-submit-loader");
    if (loaderBlock.length && submitBtn.length) {
        OrderSubmitLoader.addOrderSubmitListener(submitBtn);
    }
});